const Layout = () => import('@/layout/index.vue')

export default {
  name: 'AirDetail',
  path: '/:language?/airdetail',
  component: Layout,
  redirect: '/airdetail/index',
  children: [
    {
      name: 'AirDetailIndex',
      path: 'index',
      component: () => import('@/views/airdetail/index.vue'),
      meta: {
        title: 'viaim AIR- Wireless Earphones Singapore',
        hideTab: false,
        menu: 'AirDetail',
        description: 'Experience the ultimate convenience and freedom with our top-of-the-line WIRELESS EARPHONES SINGAPORE. Shop now for the best deals!',
        image:'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/airdetail/bannerair.png'
      }
    }
  ]
}
